import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { Container } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";

const PATH_PREFIX = "page.register.submission-complete";

export default function Page() {
  const locale = useLocale();

  return (
    <>
      <Banner
        title={<DynamicText path={`${PATH_PREFIX}.title.${locale}`} tag="h1" />}
        image={{ path: `${PATH_PREFIX}.banner.image`, src: "/assets/banners/default.webp" }}
      />
      <div className="py-4 py-md-5 mb-5">
        <Container>
          <DynamicHtml path={`${PATH_PREFIX}.content.${locale}`} />
        </Container>
      </div>
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerKey = "form.complete";
  const titleKey = `${PATH_PREFIX}.title`;

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          link: router[routerKey]["en"],
        },
      },
      router: router[routerKey],
    },
  };
}
